import { actionCopyEnUs } from "./actionCopy";

export const ratingsListCopyEnUs = {
    addActivityPlaceholder: (current: number, max: number) => `Add activity ${current}/${max}`,
    add: actionCopyEnUs.add,
    emptyHint: "Add activities above to begin rating your difficulty",
    noDifficulty: "No difficulty",
    unableToDo: "Unable to do",
    loading: "Loading activities...",
    loadError: "Unable to load your activity list. Please try again.",
    noBaselineActivities:
        "No baseline activities were found for this tracker. Complete the first entry before submitting a follow-up.",
    followUpHint: "Rate your current difficulty with each activity you chose at baseline.",
};
